import { render, staticRenderFns } from "./user-items-primary.vue?vue&type=template&id=d5024e88&scoped=true"
import script from "./user-items-primary.vue?vue&type=script&lang=js"
export * from "./user-items-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5024e88",
  null
  
)

export default component.exports